import Model from 'backbone-model';

import Entity from 'lib/Entity';

class Teacher extends Entity {
  getName() {
    return this.get('name');
  }

  getFirstName() {
    return this.get('first_name') || '';
  }

  getLastName() {
    return this.get('last_name') || '';
  }

  getFullName() {
    return `${this.getFirstName()} ${this.getLastName()}`;
  }

  getPreview() {
    return this.get('preview');
  }

  getState() {
    return this.get('state');
  }
  setState(state: any): Model.Model {
    return this.set({ state });
  }

  isAvailable() {
    return this.getState() === 'available';
  }

  isUnavailable() {
    return this.getState() === 'unavailable';
  }

  isInvitable() {
    return this.getState() === 'invitable';
  }

  isInvited() {
    return this.getState() === 'invited';
  }

  getType() {
    return this.get('type');
  }

  isUser() {
    return this.getType() === 'user';
  }

  isLead() {
    return this.getType() === 'lead';
  }
}

export default Teacher;
